import { render } from "./detalTrip.vue?vue&type=template&id=2af1f668&scoped=true"
import script from "./detalTrip.vue?vue&type=script&lang=js"
export * from "./detalTrip.vue?vue&type=script&lang=js"

import "./detalTrip.vue?vue&type=style&index=0&id=2af1f668&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af1f668"]])

export default __exports__